var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';

/**
 * Get Styled Component fieldset theme
 * @param options GetFieldsetThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getFieldsetTheme = function getFieldsetTheme(options) {
  var look = options.look;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    .bf-fieldset__standard-legend {\n      color: ", ";\n    }\n  "])), function (_ref) {
    var theme = _ref.theme;
    return theme.fieldset[look].backgroundColor;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.fieldset[look].borderColor;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.fieldset[look].textColor;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.fieldset[look].textColor;
  });
};
export { getFieldsetTheme };